import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { KeycloakAuthService } from '../services/keycloak-auth.service';

/**
 * Interceptor per gestire errori di autenticazione su richieste verso le API TMS.
 *
 * Il token di autenticazione è gestito automaticamente via httpOnly cookie dal backend.
 * Questo interceptor gestisce:
 * - 401 Unauthorized: effettua logout e redirect a Keycloak
 * - 403 Forbidden (CSRF token invalid): effettua logout locale
 */
export const keycloakAuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const keycloakAuth = inject(KeycloakAuthService);
  const isV1Endpoint = req.url.includes('/api/v1/');

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isV1Endpoint) {
        keycloakAuth.logout().catch(console.error);
      } else if (error.status === 403 && !isV1Endpoint) {
        keycloakAuth.logoutLocal().catch(console.error);
      }
      return throwError(() => error);
    })
  );
};
